//日期转换
import {base64decode, utf8to16} from "./dakabase64";
import {goodsTypes} from './commonData'
import Axios from 'axios';
import {myIdentify, myTrack} from "./track";

export function formatDate(date, format) {
    if (date instanceof Date) {
        var o = {
            "M+": date.getMonth() + 1,
            "d+": date.getDate(),
            "h+": date.getHours(),
            "m+": date.getMinutes(),
            "s+": date.getSeconds(),
            "q+": Math.floor((date.getMonth() + 3) / 3),
            "S": date.getMilliseconds()
        };
        if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
        return format;
    } else {
        return "";
    }
}

//检测是否车牌号
export function isVehicleNo(value) {
    let vehicleNo01 = /^[\u4e00-\u9fa5]{1}[A-Za-z0-9]{6}$/;
    let vehicleNo02 = /^[\u4e00-\u9fa5]{2}[A-Za-z0-9]{5}$/;
    let vehicleNo03 = /^[\u4e00-\u9fa5]{1}[A-Za-z0-9]{5}[\u4e00-\u9fa5]{1}$/;
    let vehicleNo04 = /^[\u4e00-\u9fa5]{1}[A-Za-z0-9]{7}$/;
    let vehicleNo05 = /^[\u4e00-\u9fa5]{2}[A-Za-z0-9]{6}$/;
    let vehicleNo06 = /^[\u4e00-\u9fa5]{1}[A-Za-z0-9]{6}[\u4e00-\u9fa5]{1}$/;
    let result = vehicleNo01.test(value) || vehicleNo02.test(value) || vehicleNo03.test(value) || vehicleNo04.test(value) || vehicleNo05.test(value) || vehicleNo06.test(value);
    return result;
}

//校验手机号
export function isPhoneNum(str) {
    //要求11位数字
    let reg = /(^1[3|4|5|7|8|9]\d{9}$)|(^09\d{8}$)/;
    return reg.test(str)
}

//校验邮箱格式
export function isEmail(str) {
    let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
    return reg.test(str);
}

//校验身份证格式
export function isIdCard(str) {
    let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    return reg.test(str);
}

//校验护照格式
export function isPassport(str) {
    let reg = /^[a-zA-Z0-9]{3,21}$/;
    return reg.test(str);
}

//校验军人证格式
export function isServicemanCard(str) {
    let reg = /^[a-zA-Z0-9]{7,21}$/;
    return reg.test(str);
}

//校验港澳通行证格式
export function isPassCard(str) {
    let reg = /^[a-zA-Z0-9]{5,21}$/;
    return reg.test(str);
}

//校验驾驶证格式
export function isDriverLicense(str) {
    let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    return reg.test(str);
}

//校验港澳回乡证或台胞证格式
export function isTaiPassCard(str) {
    let reg = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
    return reg.test(str);
}

//数字和字母
export function onlyNumAndChar(str) {
    let reg = new RegExp(/^[0-9A-Za-z]+$/);
    return reg.test(str);
}

//特殊字符
export function checkSpecialChar(str) {
    let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
    let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

    return regEn.test(str) || regCn.test(str);
}

//取用户信息
export function getUserInfo(resolveFn) {
    let info = {};
    if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
        //微信
    } else if (navigator.userAgent.indexOf('AlipayClient') > -1) {
        //支付宝
        let data = JSON.parse(getUrlParams().userInfo);
        info.mobile = data.phone;
        info.userId = data.userId;
    } else if (navigator.userAgent.indexOf("daka") > -1) {
        //大卡
        try {
            if (getSessionObj("dakaUser")) {
                info = getSessionObj("dakaUser");
                return info
            } else {
                let merchantcode = "20200520135233717082";
                if (process.env.VUE_APP_TITLE === "prod") {
                    merchantcode = "20200520135233717082";
                } else if (process.env.VUE_APP_TITLE === "test") {
                    merchantcode = "20190606175732387233";
                }
                h5_native.login(merchantcode, function (d) {
                    let oStr = '';
                    let postData = {tiket: d.code};
                    postData = (function (value) {
                        for (let key in value) {
                            oStr += key + "=" + value[key] + "&";
                        }
                        return oStr;
                    }(postData));
                    Axios.post('/hsbxjj-insurance-sales/usercenter/getUserInfoByDakaTiket?=' + Math.random(), postData, {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    }).then(res => {
                        try {
                            // myTrack("login返回参数", {
                            //     'data': JSON.stringify(res),
                            // });
                        } catch (e) {
                        }
                        info.mobile = res.data.data.regPhoneDecrypt;
                        info.userId = res.data.data.userId;
                        info.nickName = res.data.data.userNickName;
                        info.avatar = res.data.data.headPic;//头像
                        info.sex = res.data.data.userSex;//1 男 2 女
                        setSessionObj("dakaUser", info);
                        try {
                            // zhugeT(info);
                            myIdentify(info)
                        } catch (e) {
                        }
                        resolveFn ? resolveFn(info) : '';
                    })
                });
            }
        } catch (e) {
            info.mobile = "";
            info.userId = "";
            resolveFn ? resolveFn(info) : '';
        }
    } else if (window.getUserInfoForHB) {
        let data = window.getUserInfoForHB();
        info.mobile = data.mobile;
        info.userId = data.userId;
        info.loginName = data.loginName;
    }
    //测试
    // info.mobile = "13203591111";
    if (!resolveFn) {
        return info;
    }
}

//取浏览器参数
export function getUrlParams() {
    let search = location.search.substr(1);
    let params = search.split("&");
    let data = {};
    for (let i = 0; i < params.length; i++) {
        if (params[i].split("=")[0] != "v") {
            data[params[i].split("=")[0]] = decodeURIComponent(params[i].split("=")[1]);
        }
    }
    return data;
}

//提示信息
export function showMsg(text) {
    let error = document.querySelector('.error-tips');
    let errorChild;
    if (!error) {
        error = document.createElement('div');
        errorChild = document.createElement('span');
        error.classList.add('error-tips');
        error.classList.add('hide');
        document.body.appendChild(error);
        error.appendChild(errorChild);
    } else {
        errorChild = error.querySelector('span');
        if (!errorChild) {
            errorChild = document.createElement('span');
            error.appendChild(errorChild);
        }
    }
    errorChild.innerText = text;
    error.classList.remove('hide');
    error.classList.add('fade-out');
    setTimeout(() => {
        errorChild.innerText = "";
        error.classList.remove('fade-out');
        error.classList.add('hide');
    }, 1950);
}

//获得字符串实际长度，中文2，英文1
export function getRealLength(str) {
    let realLength = 0, len = str.length, charCode = -1;
    for (let i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode >= 0 && charCode <= 128)
            realLength += 1;
        else
            realLength += 2;
    }
    return realLength;
}

//存入session
export function setSessionObj(key, value) {
    if (window.sessionStorage) {
        return window.sessionStorage[key] = JSON.stringify(value);
    }
}

//取session
export function getSessionObj(key) {
    if (window.sessionStorage) {
        if (window.sessionStorage[key]) {
            return JSON.parse(window.sessionStorage[key]);
        }
    }
    return null;
}

//获取页面来源
export function getSceneLabel() {
    let label = "浏览器";
    if (window.daka) {
        label = "大卡App";
    } else if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
        label = "微信";
    } else if (navigator.userAgent.indexOf('AlipayClient') > -1) {
        label = "支付宝";
    }
    return label;
}

//判断是否Android
export function isAndroid() {
    let u = navigator.userAgent;
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}

//版本号比较
export function appVersionCompare(effectiveVal, nowVal) {
    const effectiveVersion = Number(effectiveVal.replace(/[^0-9]/ig, ""));
    const nowVersion = Number(nowVal.replace(/[^0-9]/ig, ""));
    return nowVersion >= effectiveVersion;
}

//判断是否Ios
export function isIOS() {
    let u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

//拷贝对象
export function deepClone(obj) {
    let _obj = JSON.stringify(obj);
    let objClone = JSON.parse(_obj);
    return objClone;
}

//时间格式转换
export function getDefaultDate(time) {
    let date;
    if (!time) {
        date = new Date();
        date.setDate(date.getDate() + 1);
    } else {
        date = new Date(time);
    }
    //空格隔开
    return formatDate(date, "yyyy年 M月 d日");
}

//转换货物类型
export function getGoodsType(type) {
    for (let i = 0; i < goodsTypes.length; i++) {
        if (goodsTypes[i].id === type) {
            return goodsTypes[i].value;
        }
    }
}

//转换地址
export function transAddress(address) {
    //中转地可能为空
    if (address) {
        let addressArray = address.split("-");
        if (address.indexOf("北京市") >= 0 || address.indexOf("天津市") >= 0 || address.indexOf("上海市") >= 0 || address.indexOf("重庆市") >= 0) {
            return addressArray[1] + addressArray[2];
        } else {
            return addressArray[0] + addressArray[1];
        }
    } else {
        return ''
    }
}

// function zhugeT(info) {
//     myTrack("getUserId正常获取", {
//         'id': info.userId || "",
//     });
//     myIdentify(info.userId, {
//         name: info.nickName,
//         avatar: info.avatar,
//         "用户性别": (function (sex) {
//             if (sex === "1") {
//                 return "男"
//             } else if (sex === "2") {
//                 return "女"
//             } else {
//                 return ""
//             }
//         })(info.sex),
//         "注册时间": "",
//         "用户生日": "",
//         "绑定手机": info.mobile,
//         "所在城市": "",
//         "实名认证状态": ""
//     });
// }
/**
 * 获得上周周一、周日的年月日  
 */
export function getLastWeekData() {
    var lastweek = {};
    var date = new Date();

    date.setDate(date.getDate()-7 - date.getDay() + 1);
    lastweek.start_day = date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日";


    date.setDate(date.getDate() +6);
    lastweek.end_day = date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + "日";
    return lastweek
} 
/**
 * 获得上月第一天、最后一天的年月日  
 */
export function getLastMonthData() {
    var nowdays = new Date();
    var year = nowdays.getFullYear();
    var month = nowdays.getMonth();
    if(month==0){
        month = 12;
        year = year-1;
    }
    if(month<10){
        month = '0'+month;
    }
    var myDate = new Date(year,month,0);
    var startDate = year+'年'+month+"月"+'01日';
    var endDate = year+'年'+month+"月"+myDate.getDate()+'日';
    return {
        start_day:startDate,
        end_day:endDate,
    }
}

//判断是否isUniapp
export function isUniapp() {
    const agent = window.navigator.userAgent;		
    var aflag = agent.indexOf("zjcw-app");
    if(aflag != -1){        
        return 1;
    } else {
        return 0;
    }
}